import IonIcon from '@reacticons/ionicons'
import React, { Dispatch } from 'react'
import Modal from 'react-modal'
import { useDispatch } from 'react-redux'
import { resendEmail } from 'src/services/common/resendEmail'
import { showToast } from 'src/store/actions/toastAction'

interface VerifyEmailModalProps {
  isOpen: boolean
  email: string
  onClose: () => void
}

const ModalStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    padding: '0px',
    transform: 'translate(-50%, -50%)',
    borderWidth: '0px',
    backgroundColor: 'transparent',
    border: '0px solid red',
  },
}

export const VerifyEmailModal: React.FC<VerifyEmailModalProps> = ({ isOpen, email, onClose }) => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const dispatch: Dispatch<any> = useDispatch()

  const handleClose = () => {
    onClose()
  }
  const handleResendEmail = async () => {
    const res = await resendEmail(email)
    dispatch(showToast(res, 'info'))
  }

  return (
    <Modal closeTimeoutMS={200} isOpen={isOpen} onRequestClose={handleClose} style={ModalStyles}>
      <div className="flex flex-col w-[510px]">
        <div className="flex flex-row w-full z-10">
          <div className="ml-auto cursor-pointer text-textdark relative" onClick={handleClose}>
            <div className="w-4 h-4 m-2 rounded-md bg-white absolute z-20"></div>
            <IonIcon name="close-circle" className="!h-[30px] !w-[30px] relative z-30" />
          </div>
        </div>

        <div className="flex flex-col overflow-y-hidden mt-[-25px] mr-[15px]">
          <div className="bg-white rounded-[5px] flex flex-row w-full">
            <div className="flex flex-col w-full">
              <div className="h-2 bg-navy rounded-t-[5px]"></div>
              <div className="flex flex-col p-12 text-[16px] font-primary text-darkgray">
                <p className="flex text-[30px] font-bold font-secondary text-navy">Verify your email</p>
                <div className="flex flex-wrap my-[15px]">
                  <p>
                    Please verify your email address to benefit the full <br />
                    feature of the site. If you have not received a <br />
                    verification email, please contact administrator.
                  </p>
                </div>
                <div>
                  <div
                    className="text-white font-secondary text-[14px] font-bold text-center rounded-[22.5px] px-[25px] bg-navy w-[150px] h-[45px] my-4 items-center flex cursor-pointer"
                    onClick={handleResendEmail}
                  >
                    Resend Email
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </Modal>
  )
}
